import { useTranslation } from "react-i18next"

import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import { useEnrolledCoursesData } from "@/queries/queries"

import RoundCard from "./RoundCard"

export default function EnrolledCoursesShow() {
  const enrolledRoundsQuery = useEnrolledCoursesData()

  const { t } = useTranslation()

  if (enrolledRoundsQuery.isLoading) return <Loading />
  if (!enrolledRoundsQuery.data?.data)
    return <NoMessage name={t("noMessages.courses")} />

  return (
    <div>
      <div className="cards-con">
        {enrolledRoundsQuery.data.data.map((ele) => {
          return <RoundCard key={ele?.id} ele={ele} />
        })}
      </div>
      <Pagination pagination={enrolledRoundsQuery.data.meta} />
    </div>
  )
}
